import { Link } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

const NavLinks = () => {
  const { user, loading } = useAuth();
  const linkClass = "text-solr-starfield-white hover:text-solr-nebula-purple transition-colors focus:outline-none focus:ring-2 focus:ring-solr-nebula-purple focus:ring-offset-2 focus:ring-offset-transparent rounded-md px-2 py-1 min-h-[44px] flex items-center";
  
  return (
    <>
      <Link to="/" className={linkClass} role="menuitem">
        Home
      </Link>
      <Link to="/shop" className={linkClass} role="menuitem">  
        Shop
      </Link>
      <Link to="/about" className={linkClass} role="menuitem">
        About
      </Link>
      <Link to="/ingredients" className={linkClass} role="menuitem">
        Ingredients
      </Link>
      <Link to="/faq" className={linkClass} role="menuitem">
        FAQ
      </Link>
      <Link to="/referral" className={linkClass} role="menuitem">
        Referral
      </Link>
      {!loading && (
        user ? (
          <Link to="/dashboard" className={linkClass} role="menuitem">
            Dashboard
          </Link>
        ) : (
          <Link to="/auth" className={linkClass} role="menuitem">
            Sign In
          </Link>
        )
      )}
    </>
  );
};

export default NavLinks;
